export const initModal = () => {
	const modals = document.querySelectorAll('.js-modal');
	if (!modals.length) return;
	modals.forEach((element) => new Modal(element));
};

// export const initAddProductCartModal = () => {
//     const wrapper = document.querySelector('.offcanvas-wrapper');
//     const modals = document.querySelectorAll('.offcanvas-cart');
//
//     if (!modals.length || !wrapper) return;
//
//     modals.forEach((element) => {
//         new Modal(element);
//
//         if (window.location.hash === '#added_product') {
//             wrapper.classList.add('open');
//             element.classList.add('open');
//         }
//
//         const closeButton = element.querySelector('.js-close');
//         if (closeButton) {
//             closeButton.addEventListener('click', () => {
//                 wrapper.classList.remove('open');
//                 element.classList.remove('open');
//                 if (window.location.hash === '#added_product') {
//                     history.replaceState(null, null, window.location.pathname);
//                 }
//             });
//         }
//
//         const overlay = wrapper.querySelector('.offcanvas-background-overlay');
//         if (overlay) {
//             overlay.addEventListener('click', () => {
//                 wrapper.classList.remove('open');
//                 element.classList.remove('open');
//             });
//         }
//
//     });
// }

class Modal {

	constructor(element) {
		this.element = element;
		this.id = element.dataset.modalId;
		this.addEventListeners();
		this.openIfQueried();
	}

	addEventListeners() {
		const id = this.id;
		if (!id) {
			console.warn('No ID supplied for .js-modal element.');
			return;
		}
		const triggers = document.querySelectorAll(`[data-modal-trigger="${id}"]`);
		if (!triggers.length) {
			console.warn(`Modal with ID "${id}" has no triggers.`);
		}
		const closes = this.element.querySelectorAll(`[data-modal-close="${id}"]`);
		if (!closes.length) {
			console.warn(`Modal with ID "${id}" does not have any closing elements.`)
		}

		closes.forEach((close) =>
			close.addEventListener('click',
				this.close.bind(this)));

		triggers.forEach((trigger) =>
			trigger.addEventListener('click',
				this.open.bind(this)));

		this.element.querySelector('[data-modal-wrapper]')
			.addEventListener('click', (event) =>
				event.stopPropagation());

		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape') this.close(event);
		});
	}

	openIfQueried() {
		if (location.search.includes('modal-trigger'))
			this.open();
	}

	open() {
		this.element.classList.add('open');
	}

	close(event) {
		event.stopPropagation();
		this.element.classList.remove('open');
	}
}